import { create } from 'zustand'
import { EventData } from '../types/events'

/**
 * Union type for all possible modal data types
 * Add new types here as more modals require data
 */
export type ModalData = EventData | null

/**
 * Store for modal-specific data
 * Separated from ModalStore to handle data independently
 */
interface ModalDataStore {
    data: ModalData
    setData: (data: ModalData) => void
    clearData: () => void
    getData: <T extends ModalData = ModalData>() => T
}

const useModalDataStore = create<ModalDataStore>((set, get) => ({
    data: null,

    setData: (data) => set({ data }),
    clearData: () => set({ data: null }),
    getData: <T extends ModalData = ModalData>() => {
        const data = get().data
        return data as T
    },
}))

export { useModalDataStore }

